import CateringProvider from 'components/CateringProvider';
import useMerchantPath from 'hooks/useMerchantPath';
import { getDeliveryMethodSchema, getMenusSchema, getOpeningHoursSchema } from 'pages/Merchant/utils';

const useStructuredData = ({ merchant, menus }) => {
  const merchantPath = useMerchantPath(merchant);
  return ({
    '@context': 'http://schema.org/',
    '@type': 'Restaurant',
    '@id': `${window.location.origin}/pwa${merchantPath}`,
    url: `${window.location.origin}/pwa${merchantPath}`,
    name: merchant?.name,
    description: merchant?.description,
    address: merchant?.address,
    starRating: {
      '@type': 'Rating',
      bestRating: '5',
      ratingValue: merchant?.rating,
      worstRating: '1',
    },
    priceRange: '$'.repeat(merchant?.price_class || 1),
    paymentAccepted: 'Cash, Credit Card',
    logo: merchant?.logo,
    telephone: merchant?.phone,
    latitude: merchant?.location?.lat,
    longitude: merchant?.location?.lng,
    keywords: 'Order Online, Food Delivery, Takeout, Restaurant Delivery',
    servesCuisine: merchant?.tags?.map((t) => t.title),
    openingHoursSpecification: getOpeningHoursSchema(merchant?.open_times || {}),
    potentialAction: {
      '@type': 'OrderAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${window.location.origin}/pwa${merchantPath}`,
        inLanguage: 'English',
        actionPlatform: [
          'https://schema.org/DesktopWebPlatform',
          'https://schema.org/MobileWebPlatform',
        ],
      },
      deliveryMethod: getDeliveryMethodSchema(merchant),
    },
    hasMenu: {
      '@type': 'Menu',
      name: 'Dine-In Menu',
      hasMenuSection: getMenusSchema(menus),
    },
  });
};

export default useStructuredData;
